import SalePlanTemplate from "@/pages/salePlanTemplate/index.tsx";

const SalePlanTemp = () => {
  return <SalePlanTemplate templateType={'TRACK_PLAN'}/>
}

export default SalePlanTemp